import { useQuery } from '@tanstack/react-query'

import type { Evaluation } from '../types/evaluation'

import { api } from '@/shared/services/api'

export const EVALUATIONS_QUERY_KEY = ['/user/evaluations'] as const

export function useEvaluations() {
  const query = useQuery({
    queryKey: EVALUATIONS_QUERY_KEY,
    queryFn: async () => {
      const { data } = await api.get<{ records: Evaluation[] }>('/user/evaluations')
      return data.records
    }
  })

  return { ...query, evaluations: query.data ?? [] }
}

export function useEvaluation(id: number | string) {
  const query = useQuery({
    queryKey: ['/user/evaluations', String(id)],
    enabled: !!id,
    queryFn: async () => {
      const { data } = await api.get<{ record: Evaluation }>(`/user/evaluations/${id}`)
      return data.record
    }
  })

  return { ...query, evaluation: query.data }
}
